import { useQuery } from "@tanstack/react-query";

import { getMe } from "@/api/meApi";
import { meKeys } from "@/api/meKeys";
import { consumeAccessTokenHint } from "@/lib/accessTokenHint";
import type { MeResponse } from "@/types/api/me";

export const ME_STALE_TIME_MS = 5 * 60 * 1000;

type UseMeOptions = {
  enabled?: boolean;
};

export function useMe(options?: UseMeOptions) {
  return useQuery<MeResponse>({
    queryKey: meKeys.detail(),
    queryFn: ({ signal }) => getMe(consumeAccessTokenHint(), { signal }),
    enabled: options?.enabled ?? true,
    staleTime: ME_STALE_TIME_MS,
  });
}
